module.exports = __webpack_public_path__ + "img/img_faguang_right.4f4d6abd.png";